import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// 是否为手机端
function ISMOBILE() {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}
//登录
import routerM  from './routerM';
import routerPC  from './routerPC';
//
//根据不同客户端加载路由
Vue.use(VueRouter)
// 创建路由实例
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  fallback: false,
  // 这里判断后选择使用移动端的路由还是pc端的路由
  routes: ISMOBILE() ? routerM : routerPC,
});

//原有路由
// const router = new VueRouter({
//   // mode: 'history',
//   mode: 'hash',
//   base: process.env.BASE_URL,
//   routes
// })

export default router
